<template lang='pug' src='./custom-office-tour.pug'></template>

<script>

export default {
  props: ['props'],
  data () {
    return {
      titleActive: null,
      videoPlaying: null,
      videoLoading: null
    }
  },

  methods: {
    playPauseVideo () {
      let video = this.$refs.video
      if (this.videoPlaying) {
        this.videoPlaying = false
        video.pause()
      } else {
        this.videoPlaying = true
        video.play()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-office-tour.vue?e16c8462